// @flow
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Highlight } from 'react-instantsearch/dom';
import styled from 'styled-components';

import {
    showDeletePropertyPrompt,
    showDuplicatePropertyPrompt,
    toLetBoardShow,
} from '../../redux/reducers/property';

import { formatRent, formatSize } from '../../shared/utils';

const StyledResultsRow = styled.tr`
    font-weight: lighter;
    background: #f3f3f5;
    font-size: 14px;

    &:nth-of-type(odd) {
        background: #fff;
    }

    & th {
        font-weight: normal;
        background: #edf1f2;
        border-bottom: 1px solid #d9d9db;
        padding: 15px 20px;
        text-align: left;
    }

    & td {
        padding: 10px 20px;
    }

    & .actions {
        /*width: 1%;*/
        /*white-space: nowrap;*/
        float: right;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        width: 66px;

        @media (min-width: 1300px) {
            width: 139px;
        }

        .action-btn:last-child {
            margin-right: 0;
        }
    }

    & .actions .action-btn {
        position: relative;
        display: inline-block;
        padding: 5px 8px;
        color: #fff;
        text-decoration: none;
        background: #e76424;
        border: none !important;
        font-weight: lighter !important;
        font-size: 14px !important;
        line-height: 16px !important;
        cursor: pointer;
        border-radius: 4px;
        border: none;

        margin: 8px 0 0;

        @media (min-width: 1300px) {
            margin: 8px 0;
        }
    }

    & .actions .action-btn .tooltip {
        position: absolute;
        font-size: 12px;
        width: 140px;
        color: #ffffff;
        background: #48555b;
        height: 30px;
        line-height: 30px;
        text-align: center;
        visibility: hidden;
        border-radius: 4px;
    }

    & .actions .action-btn .tooltip-wide {
        width: 200px;
    }

    & .actions .action-btn .tooltip:after {
        content: '';
        position: absolute;
        top: 50%;
        left: 100%;
        margin-top: -8px;
        width: 0;
        height: 0;
        border-left: 8px solid #48555b;
        border-top: 8px solid transparent;
        border-bottom: 8px solid transparent;
    }
    & .actions .action-btn:hover .tooltip {
        visibility: visible;
        right: 100%;
        top: 50%;
        margin-top: -15px;
        margin-right: 13px;
        z-index: 999;
    }
`;

let ListItem = ({ hit, onDelete, onDuplicate, onToLetBoardClick }) => {
    return (
        <StyledResultsRow>
            <td>
                <Highlight
                    attributeName="PropertyReference"
                    hit={hit}
                    tagName="mark"
                />
            </td>
            <td>
                {hit.PropertyName}
            </td>
            <td>
                <Highlight
                    attributeName="PropertyTownCity"
                    hit={hit}
                    tagName="mark"
                />
            </td>
            <td>
                <Highlight
                    attributeName="PropertyPostcode"
                    hit={hit}
                    tagName="mark"
                />
            </td>
            <td>
                {formatRent(hit.PropertyRent)}
            </td>
            <td>
                {formatSize(hit.PropertySize)}
            </td>
            <td>
                <div className="actions">
                    <Link
                        className="action-btn"
                        to={`/property/edit/${hit.PropertyReference}`}
                    >
                        <i className="fa fa-pencil" />
                        <span className="tooltip">Edit Property</span>
                    </Link>

                    <button className="action-btn" onClick={onDuplicate}>
                        <i className="fa fa-clone" />
                        <span className="tooltip">Duplicate Property</span>
                    </button>

                    <button className="action-btn" onClick={onToLetBoardClick}>
                        <i className="fa fa-wrench" />
                        <span className="tooltip tooltip-wide">
                            Add/Remove To Let Board
                        </span>
                    </button>

                    <button className="action-btn" onClick={onDelete}>
                        <i className="fa fa-trash" />
                        <span className="tooltip">Delete Property</span>
                    </button>
                </div>
            </td>
        </StyledResultsRow>
    );
};

const listItemMapDispatchToProps = (dispatch, ownProps) => {
    const propertyId = ownProps.hit.PropertyId;
    const propertyReference = ownProps.hit.PropertyReference;

    return {
        onDelete: () => {
            dispatch(showDeletePropertyPrompt(propertyId, propertyReference));
        },
        onDuplicate: () => {
            dispatch(
                showDuplicatePropertyPrompt(propertyId, propertyReference)
            );
        },
        onToLetBoardClick: () => {
            dispatch(toLetBoardShow(propertyReference));
        },
    };
};

export default connect(() => {
    return {};
}, listItemMapDispatchToProps)(ListItem);



// WEBPACK FOOTER //
// ./src/containers/PropertySearch/PropertySearchListItem.js